import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class EmailConfirmed extends Component {
  render() {
    const LayoutWrapper = this.props.layout

    let conditionalWrecksLink
    if (this.props.layout.name === "LoggedInLayout" || this.props.layout.name === "PremiumLayout") {
      conditionalWrecksLink = <Link to="/wrecks">Click here to checkout the wreck map now.</Link>
    }

    return (
      <LayoutWrapper>
        <div className="page">
          <h2>Email Confirmed</h2>
          <p className="lead">Thank you for confirming your email address.</p>
          <p>You can now load up the Wreckfinder iOS app or Android app to begin using your account.</p>
          <p>
            You can also use Wreckfinder from your normal website browser on your mobile or desktop.<br />
            Note: the website is separate from our mobile apps, take a look and check out the wreck map<br />
            {conditionalWrecksLink}
          </p>
        </div>
      </LayoutWrapper>
    );
  }
}

export default EmailConfirmed;



// WEBPACK FOOTER //
// ./src/pages/email_confirmed.js